module.exports = __webpack_public_path__ + "html/section-text-aside_1180dbd2424cdd357ecc4a25e3e870bf.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-text-aside.html
// module id = S7Yw
// module chunks = 57